import { Outlet } from 'react-router-dom'

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <img
            src="/WORDMARK_SPECTREIQ_HORIZONTAL_WHITE.svg"
            alt="SPECTREIQ"
            className="h-12 max-w-full object-contain"
          />
        </div>
        <Outlet />
      </div>
    </div>
  )
}
